var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 42,
    viewBox: "0 0 35 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2335 20.8393C23.2317 20.8393 28.0942 16.1743 28.0942 10.4197C28.0942 4.66504 23.2317 0 17.2335 0C11.2353 0 6.3728 4.66504 6.3728 10.4197C6.3728 16.1743 11.2353 20.8393 17.2335 20.8393Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00995712 35.3132C-0.0027418 34.5591 0.168365 33.8127 0.509755 33.1333C1.26052 32.1709 2.20789 31.3654 3.29386 30.7658C4.37984 30.1661 5.58173 29.7849 6.82628 29.6456C8.57911 29.2928 10.3559 29.0597 12.1431 28.9481C15.4614 28.6647 18.7992 28.6647 22.1175 28.9481C23.9063 29.0578 25.6837 29.2983 27.4343 29.6675C29.8655 30.147 32.7965 31.1061 33.8417 33.1988C34.1854 33.8781 34.364 34.6235 34.364 35.3786C34.364 36.1338 34.1854 36.8791 33.8417 37.5585C32.7965 39.7383 29.8655 40.6102 27.4343 41.068C25.6846 41.4458 23.907 41.6937 22.1175 41.8092C19.4193 42.0198 16.7094 42.0562 14.0061 41.9182C13.3819 41.9397 12.7573 41.8958 12.1431 41.7874C10.3601 41.6811 8.58933 41.4331 6.84903 41.0462C5.57658 40.9514 4.34121 40.59 3.23021 39.9874C2.11921 39.3848 1.15958 38.5556 0.41892 37.5585C0.0998837 36.8515 -0.040244 36.0821 0.00995712 35.3132Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user_placeholder.c2e4261c94ef4f811397a76969cde77a.svg";
export { ForwardRef as ReactComponent };